unit DieselAttendantSetup;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  VCL.TMSFNCEdit, WEBLib.ExtCtrls, WEBLib.DBCtrls, Data.DB, WEBLib.DB,
  XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client;

type
  TfrmDieselAttendantSetup = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    wcFuelAttendants: TXDataWebClient;
    wdsFuelAttendants: TXDataWebDataSet;
    dsFuelAttendant: TDataSource;
    WebDBEdit1: TDBEdit;
    WebDBEdit2: TDBEdit;
    wdsFuelAttendantsATTNO: TIntegerField;
    wdsFuelAttendantsNAME: TStringField;
    wdsFuelAttendantsSUSPENDED: TBooleanField;
    wdsFuelAttendantspassword: TStringField;
    cbxSuspended: TDBCheckBox;
    WebButton1: TButton;
    WebButton2: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure cbxSuspendedClick(Sender: TObject);
  private
    { Private declarations }
    procedure LoadFuelAttendants;
  public
    { Public declarations }
    iAttno , iState: Integer;
  protected procedure LoadDFMValues; override; end;

var
  frmDieselAttendantSetup: TfrmDieselAttendantSetup;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.system.classes , share.common;

procedure TfrmDieselAttendantSetup.cbxSuspendedClick(Sender: TObject);
begin
  wdsFuelAttendants.FieldByName('SUSPENDED').AsBoolean := cbxSuspended.Checked;
end;

procedure TfrmDieselAttendantSetup.LoadFuelAttendants;
procedure OnResultError(Error: TXDataClientError);
    begin
      LoadFuelAttendants;
    end;

  procedure OnResultNumbers(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadFuelAttendants;
        end
      else
        begin
          wdsFuelAttendants.Close;
          wdsFuelAttendants.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsFuelAttendants.Open;

          wdsFuelAttendants.Edit;
        end;

    end;
begin
   wcFuelAttendants.RawInvoke('IstfmsdieselService.Get_FuelAttendants_View',[0,iAttno],@OnResultNumbers,@OnResultError);
end;

procedure TfrmDieselAttendantSetup.WebButton1Click(Sender: TObject);
  procedure OnSuccess(Response : TXDataClientResponse);
    begin
      wdsFuelAttendants.Cancel;
      Close;
    end;
  procedure OnError(Error: TXDataClientError);
    begin
      ShowMessage(Error.ErrorMessage);
      Close;
    end;
begin
  case iState of
    1:  Begin
          console.log(GetJsonFromDataSet(wdsFuelAttendants));
          wcFuelAttendants.RawInvoke('IstfmsdieselService.Put_FuelAttendant_Insert',[GetJsonFromDataSet(wdsFuelAttendants)],@OnSuccess, @OnError);
        End;
    2:  Begin
          wcFuelAttendants.RawInvoke('IstfmsdieselService.Put_FuelAttendant_Edit',[GetJsonFromDataSet(wdsFuelAttendants)],@OnSuccess, @OnError);
        End;
  end;
end;

procedure TfrmDieselAttendantSetup.WebButton2Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmDieselAttendantSetup.WebFormShow(Sender: TObject);
begin
  case iState of
    1 : Begin
          wdsFuelAttendants.Open;
          wdsFuelAttendants.Insert;
        End;
    2 : Begin
          LoadFuelAttendants;
        End;
  end;
end;

procedure TfrmDieselAttendantSetup.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  cbxSuspended := TDBCheckBox.Create(Self);
  wcFuelAttendants := TXDataWebClient.Create(Self);
  wdsFuelAttendants := TXDataWebDataSet.Create(Self);
  wdsFuelAttendantsATTNO := TIntegerField.Create(Self);
  wdsFuelAttendantsNAME := TStringField.Create(Self);
  wdsFuelAttendantsSUSPENDED := TBooleanField.Create(Self);
  wdsFuelAttendantspassword := TStringField.Create(Self);
  dsFuelAttendant := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  cbxSuspended.BeforeLoadDFMValues;
  wcFuelAttendants.BeforeLoadDFMValues;
  wdsFuelAttendants.BeforeLoadDFMValues;
  wdsFuelAttendantsATTNO.BeforeLoadDFMValues;
  wdsFuelAttendantsNAME.BeforeLoadDFMValues;
  wdsFuelAttendantsSUSPENDED.BeforeLoadDFMValues;
  wdsFuelAttendantspassword.BeforeLoadDFMValues;
  dsFuelAttendant.BeforeLoadDFMValues;
  try
    Name := 'frmDieselAttendantSetup';
    Width := 506;
    Height := 264;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 506;
    WebPanel1.Height := 264;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebLabel1.SetParentComponent(WebPanel1);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 47;
    WebLabel1.Top := 88;
    WebLabel1.Width := 91;
    WebLabel1.Height := 15;
    WebLabel1.Caption := 'Attendant Name:';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 47;
    WebLabel2.Top := 123;
    WebLabel2.Width := 53;
    WebLabel2.Height := 15;
    WebLabel2.Caption := 'Password:';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 506;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Fuel Attendants';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 204;
    WebPanel3.Width := 506;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 16;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Save';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 118;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Cancel';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebDBEdit1.SetParentComponent(WebPanel1);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 152;
    WebDBEdit1.Top := 85;
    WebDBEdit1.Width := 233;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 5;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'NAME';
    WebDBEdit1.DataSource := dsFuelAttendant;
    WebDBEdit2.SetParentComponent(WebPanel1);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 152;
    WebDBEdit2.Top := 115;
    WebDBEdit2.Width := 137;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 6;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'password';
    WebDBEdit2.DataSource := dsFuelAttendant;
    cbxSuspended.SetParentComponent(WebPanel1);
    cbxSuspended.Name := 'cbxSuspended';
    cbxSuspended.Left := 152;
    cbxSuspended.Top := 143;
    cbxSuspended.Width := 113;
    cbxSuspended.Height := 22;
    cbxSuspended.Caption := 'Suspended';
    cbxSuspended.ChildOrder := 6;
    cbxSuspended.HeightPercent := 100.000000000000000000;
    cbxSuspended.WidthPercent := 100.000000000000000000;
    SetEvent(cbxSuspended, Self, 'OnClick', 'cbxSuspendedClick');
    cbxSuspended.DataField := 'SUSPENDED';
    cbxSuspended.DataSource := dsFuelAttendant;
    wcFuelAttendants.SetParentComponent(Self);
    wcFuelAttendants.Name := 'wcFuelAttendants';
    wcFuelAttendants.Connection := dmData.dbConnect;
    wcFuelAttendants.Left := 32;
    wcFuelAttendants.Top := 16;
    wdsFuelAttendants.SetParentComponent(Self);
    wdsFuelAttendants.Name := 'wdsFuelAttendants';
    wdsFuelAttendants.Connection := dmData.dbConnect;
    wdsFuelAttendants.Left := 96;
    wdsFuelAttendants.Top := 16;
    wdsFuelAttendantsATTNO.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantsATTNO.Name := 'wdsFuelAttendantsATTNO';
    wdsFuelAttendantsATTNO.FieldName := 'ATTNO';
    wdsFuelAttendantsNAME.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantsNAME.Name := 'wdsFuelAttendantsNAME';
    wdsFuelAttendantsNAME.FieldName := 'NAME';
    wdsFuelAttendantsSUSPENDED.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantsSUSPENDED.Name := 'wdsFuelAttendantsSUSPENDED';
    wdsFuelAttendantsSUSPENDED.FieldName := 'SUSPENDED';
    wdsFuelAttendantspassword.SetParentComponent(wdsFuelAttendants);
    wdsFuelAttendantspassword.Name := 'wdsFuelAttendantspassword';
    wdsFuelAttendantspassword.FieldName := 'password';
    dsFuelAttendant.SetParentComponent(Self);
    dsFuelAttendant.Name := 'dsFuelAttendant';
    dsFuelAttendant.DataSet := wdsFuelAttendants;
    dsFuelAttendant.Left := 160;
    dsFuelAttendant.Top := 16;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    cbxSuspended.AfterLoadDFMValues;
    wcFuelAttendants.AfterLoadDFMValues;
    wdsFuelAttendants.AfterLoadDFMValues;
    wdsFuelAttendantsATTNO.AfterLoadDFMValues;
    wdsFuelAttendantsNAME.AfterLoadDFMValues;
    wdsFuelAttendantsSUSPENDED.AfterLoadDFMValues;
    wdsFuelAttendantspassword.AfterLoadDFMValues;
    dsFuelAttendant.AfterLoadDFMValues;
  end;
end;

end.